import React, { Component } from "react"
import { Card } from "react-bootstrap"
import CustomerNotification from "../../api/Notifications/Model/CustomerNotification"
import { FormatDateAsLong } from "../../formatters/FormatDate"

interface NotificationCardProps {
  notification: CustomerNotification
  index: number
  count: number
}

export class NotificationCard extends Component<NotificationCardProps, {}> {
  render() {
    const note = this.props.notification

    return <Card className="mt-2">
      <Card.Body className="p-2">
        <Card.Title>{note.NotificationTitle}</Card.Title>
        <Card.Text><small>{note.NotificationDescription}</small></Card.Text>
        <Card.Subtitle>
          <div className="float-left">({this.props.index + 1} of {this.props.count})</div>
          <div className="float-right">Expiry {FormatDateAsLong(note.NotificationExpirationDate)}</div>
        </Card.Subtitle>
      </Card.Body>
    </Card>
  }
}
